import * as React from 'react';

import { ProductSliderPlaceholder } from '@notino/react-styleguide';

import loadable from '@loadable/component';

export const ProductSlider = loadable(() => import('./LoadableProductSlider'), {
  ssr: false,
  fallback: <ProductSliderPlaceholder placeholderCount={4} rows={4} />,
});
